import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro1/Intro.jsx';
import Content from '../../components/user/sub2_5/Content.jsx';

import Footer from '../../components/user/footer/Footer.jsx';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub2_5() {
  const introData = {
    mainTitle: '제품소개',
    subTitle: '크림봇의 다양한 서비스를 만나보세요',
    menuItems: [
      { title: '서빙로봇 ', link: '/sub2_1_1', active: false },
      { title: '물류로봇 ', link: '/sub2_2', active: false },
      { title: '청소로봇  ', link: '/sub2_3_1', active: false },
      { title: '마케팅  ', link: '/sub2_4', active: false },
      { title: '매장통합관리솔루션  ', link: '/sub2_5', active: true },
    ],
  };

  return (
    <>
      <Header />
      <SubIntro
        mainTitle={introData.mainTitle}
        subTitle={introData.subTitle}
        menuItems={introData.menuItems}
      />
      <Content />
      <Footer />
    </>
  );
}
